export const DEFAULT_ALLOWED_FILE_TYPES = [
  ".jpg",
  ".jpeg",
  ".png",
  ".bmp",
  ".heic",
  ".dcm",
  ".dicom",
  ".nii",
  ".nii.gz",
  ".img",
  ".unknown",
];

export const KNOWN_DOUBLE_EXTS = [".nii.gz", ".tar.gz", ".tar.bz2"];

export const DICOM_NAMING_PATTERNS = [
  // Standard DICOM patterns
  /^(?:IM|IMAGE)\d+$/i, // IM000001, IMAGE123
  /^(?:CT|MR|XA|US|DX|CR|MG|RF)\d+$/i, // CT001, MR123, etc.
  /^\d+$/, // Pure numbers: 001, 123

  // DICOM UID patterns (simplified - real UIDs are more complex)
  /^\d+(\.\d+){3,}$/, // 1.2.840.113619.2.55.3.604688119.868.1234567890.123

  // Common medical imaging patterns
  /^DCM_?\d+$/i, // DCM001, DCM_123
  /^SLICE_?\d+$/i, // SLICE001, SLICE_123
  /^IMG_?\d+$/i, // IMG001, IMG_123

  // Manufacturer-specific patterns
  /^[A-Z]{2,4}\.\d+(\.\d+)*$/, // Patterns like "DX.1.2.250..."
  /^[A-Z]+_[A-Z]+_\d+$/i, // STUDY_SERIES_123
];

// Known medical image extensions (comprehensive list)
export const MEDICAL_EXTENSIONS = new Set([
  // Standard extensions
  ".dcm",
  ".dicom",
  ".dic",
  ".nii",
  ".nii.gz",
  ".img",
  ".hdr",
  ".mha",
  ".mhd",
  ".nrrd",
  ".nhdr",
  ".mnc",
  ".minc",

  // Image extensions
  ".jpg",
  ".jpeg",
  ".png",
  ".bmp",
  ".tiff",
  ".tif",
  ".gif",
  ".heic",
  ".heif",

  // Compressed formats
  ".zip",
  ".gz",
  ".tar",
  ".7z",
]);

export const LIKELY_NON_EXTENSIONS = [
  /^\.\d{4,}$/, // .1528707197 (timestamps)
  /^\.\d{1,3}$/, // .001, .123 (sequence numbers)
  /^\.[A-F0-9]{8,}$/i, // .ABCD1234 (hex IDs)
];

// File size limits (in bytes)
export const FILE_LIMITS = {
  MAX_POSTURAL_FILE_SIZE_BYTES: 100 * 1024 * 1024,        // 100 MB
  MAX_MEDICAL_FILE_SIZE_BYTES: 1024 * 1024 * 1024,         // 1 GB
  MAX_FILES_PER_BATCH: 10000,
  MAX_BATCH_SIZE_BYTES: 10 * 1024 * 1024 * 1024,           // 10 GB
};

// Pixel spacing constraints for DX/CR (in mm)
export const DICOM_PIXEL_SPACING = {
  MIN_MM: 0.075,
  MAX_MM: 1.0,
};

// ImageType (0008,0008) field 3 values that must be REJECTED for CT/MR
export const BLOCKED_IMAGE_TYPES_CT_MR = [
  "LOCALIZER",
  "POST-PROCESSED",
  "SCREEN SAVE",
  "SCOUT",
];

// ImageType (0008,0008) field 1-2 values that trigger a WARNING for DX/CR
export const WARNED_IMAGE_TYPES_DX_CR = [
  "DERIVED",
  "SECONDARY",
];

// Postural image extensions (for size-limit routing)
export const POSTURAL_EXTENSIONS = new Set([
  ".jpg", ".jpeg", ".png", ".bmp", ".heic",
]);
